export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative bg-[#F8F7F5] pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
              <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Critical Parts Readiness</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-[#1A2332] leading-tight mb-6">
              Critical Parts Readiness for Data Centers
            </h1>
            
            <p className="text-lg text-[#5A6670] leading-relaxed mb-8">
              BrightSync improves response predictability and operational visibility for high-urgency data center components through structured coordination and SLA-style tracking — without requiring changes to your suppliers or systems.
            </p>
            
            <button
              onClick={scrollToContact}
              className="bg-[#0A5F5C] text-white px-9 py-5 rounded-lg hover:bg-[#084A48] transition-all duration-300 font-semibold text-lg flex items-center space-x-3 group whitespace-nowrap"
            >
              <span>Request a 20-Minute Discussion</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
          
          <div className="lg:col-span-3">
            <img
              src="https://public.readdy.ai/ai/img_res/dc77eea64e4c420fcffd2a0afc94705f.jpg"
              alt="Network Coordination Visualization"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
